import { isPlainObject } from 'is-plain-object'

export const pinToString = (pin: any): string | undefined => {
  if (pin && isPlainObject(pin)) {
    return Object.keys(pin).reduce(
      (string, key) => [string, (pin as Record<string, string>)[key]].join(''),
      '',
    )
  }

  if (pin && Array.isArray(pin)) {
    return pin.join('')
  }

  return pin
}
